export default __webpack_public_path__ + "static/media/material_bg.321d95eb.svg";